import { Column } from "../../../components/dataTable/dataTable";
import { CategoryType } from "../../../types";

interface GetColumnsProps {
  currentPage: number;
  rowsPerPage: number;
  data: CategoryType[];
}

export const getColumns = ({
  currentPage,
  rowsPerPage,
  data,
}: GetColumnsProps): Column<CategoryType>[] => [
  {
    key: "index",
    label: "No.",
    align: "center",
    render: (row: CategoryType) => {
      const position = data.indexOf(row);
      if (position === -1) return "-"; // fallback (should not happen)
      return position + 1 + currentPage * rowsPerPage;
    },
  },
  { key: "name", label: "Category" },
  { key: "actions", label: "Action", align: "center" },
];
